<template>
  <v-badge overlap color="secondary" >
    <v-btn @click="$emit('gotoCart')">
      <v-icon
      large
      color="lighten-1"
    >
      {{$vuetify.icons.cart}}
    </v-icon></v-btn>
    <span slot="badge" > {{ numItems }}</span>
  </v-badge>

</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: 'CartIcon',
  computed: {
    ...mapState({
    }),
    ...mapGetters({
      numItems: 'cart/numItems'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
